export enum FileAllTableColumnsEnum {
  Name = 'name',
  Type = 'type',
  UserName = 'username',
  Status = 'status',
}
